import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateDeskGeneralDetailsRequest extends BaseUpdateRequest {
    name = '';
    businessHoursId = '';
}